import React, { useState, useMemo, useContext } from 'react';
import { Alert, Button, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DataTable from './DataTable/datatable.component';
import NoFilter from './DataTable/datatable.nofilter';
import SelectFilter from './DataTable/datatable.selectfilter';
import JobDialog from './Dialogs/JobDialog';
import { faWrench, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PrivilegesContext from './Contexts/PrivilegesContext';
import ConfirmDeleteJobDialog from './Dialogs/ConfirmDeleteJobDialog';


function JobsTable({ jobs, setJobs, updateJob, loading, error, valves, loadingValves }) {

    const { contributor, admin } = useContext(PrivilegesContext);
    const [selectedJob, setSelectedJob] = useState(null);
    const [showJobDialog, setShowJobDialog] = useState(false);
    const [showConfirmDeleteJobDialog, setShowConfirmDeleteJobDialog] = useState(false);

    const tableColumns = useMemo(() => [
        {
            Header: 'Valve',
            accessor: 'valveName',
            filter: 'fuzzyText',
            Cell: (props) => {

                const ValveNameWithDescription = () => {
                    if (props.row.original.valveDescription) {
                        return (
                            <OverlayTrigger overlay={<Tooltip>{props.row.original.valveDescription}</Tooltip>}>
                                <span className="d-flex">{props.value}</span>
                            </OverlayTrigger>
                        );
                    } else {
                        return <span>props.value</span>
                    }
                }

                return (
                    <>
                        <div className="d-md-none">
                            <ValveNameWithDescription />
                        </div>
                        <div className="d-none d-md-block">
                            {props.value}
                        </div>
                    </>
                );
            }
        },
        {
            Header: 'Areas',
            accessor: 'areas',
            filter: 'fuzzyText',
            Cell: ({ value }) => value && value.join(',')
        },
        {
            Header: 'Task',
            accessor: 'taskName',
            filter: 'fuzzyText'
        },
        {
            Header: 'Task Type',
            accessor: 'taskType',
            filter: 'fuzzyText'
        },
        {
            Header: 'Task Description',
            accessor: 'description',
            filter: 'fuzzyText'
        },
        {
            Header: 'Required operation',
            accessor: 'action',
            Filter: SelectFilter
        },
        {
            Header: () => <div className="text-center">Command time</div>,
            accessor: 'utcCreatedDate',
            Cell: (props) => {
                return (
                    <div className="text-center">
                        {
                            new Date(props.value).toLocaleDateString('en-GB', {
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit"
                            })
                        }
                    </div>
                );
            },
            Filter: NoFilter
        },
        {
            accessor: 'state',
            Header: () => <div className="text-center">Job status</div>,
            Filter: SelectFilter
        },
        {
            id: 'openDialog',
            accessor: 'id',
            Cell: (props) => {
                let disabled = loadingValves !== false;
                return (
                    <div className="d-flex justify-content-end column-gap-2">
                        {props.row.original.state !== "Completed" &&

                            <div className="text-center">
                                <Button variant="outline-primary" size="sm" className="table-btn" disabled={disabled} onClick={() => openJobDialog(props.row.original)}>
                                    <FontAwesomeIcon icon={faWrench} />
                                </Button>
                            </div>
                        }
                        <div className="text-center">
                            <Button variant="outline-primary" size="sm" className="table-btn" onClick={() => openConfirmDeleteDialog(props.row.original)}>
                                <FontAwesomeIcon icon={faTrash} />
                            </Button>
                        </div>
                    </div>
                );
            },
            Filter: NoFilter
        }
    ], [loadingValves]);


    // Set selected job and open job dialog
    const openJobDialog = (job) => {
        console.log("Selected job", job);

        setSelectedJob(job);
        setShowJobDialog(true);
    };

    // Close job dialog and clear selected job
    const closeJobDialog = () => {
        setShowJobDialog(false);
        setSelectedJob(null);
    };

    const openConfirmDeleteDialog = (job) => {
        setSelectedJob(job);
        setShowConfirmDeleteJobDialog(true);
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    if (!jobs || loading) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" />
            </div>
        );
    }

    const initialState = {
        pageSize: 20,
        sortBy: [
            {
                id: 'utcCreatedDate',
                desc: false
            }
        ],
        hiddenColumns: !contributor ? ['openDialog'] : []
    };

    const tableId = "JobsList";

    return jobs.length > 0
        ?
        <>
            <DataTable id={tableId} tableColumns={tableColumns} tableData={jobs} initialState={initialState} />
            {selectedJob !== null &&
                <>
                <JobDialog show={showJobDialog} closeDialog={closeJobDialog} job={selectedJob} updateJob={updateJob} valves={valves} />
                {admin &&
                    <ConfirmDeleteJobDialog show={showConfirmDeleteJobDialog} closeDialog={() => setShowConfirmDeleteJobDialog(false)} job={selectedJob} setJobs={setJobs} />
                }
                </>
            }
            {error &&
                <Alert variant="danger">Something went wrong. Please try again.</Alert>
            }
        </>
        :
        <div className="d-flex mt-5">
            <h4 className="text-center">No Jobs to show</h4>
        </div>
}

export default JobsTable;